<template>
  <div class="panel-body">
    <template>
      <v-card width="1000px">
      <v-data-table
        v-model="actionHistoryModel"
        :headers="headers"
        :items="actionHistory"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        item-key="id"
        class="elevation-1"
      >
      <template slot="item" slot-scope="props">
        <tr>
          <td class="text-xs-left">{{ props.item.action }}</td>
          <td class="text-xs-left">{{ props.item.amount ? "$" + props.item.amount.toFixed(2) : "" }}</td>
          <td class="text-xs-left">{{ formatDate(props.item.date) }}</td>
          <td class="text-xs-left">{{ props.item.changedByUserId }}</td>
          </tr>
      </template>
      <template slot="no-data">
      </template>
    </v-data-table>
    </v-card>
    </template>
  </div>

</template>

<script>
import moment from 'moment'
let rh = require('@/components/APIs/RequestHandler')

export default {
  props: {
    jarId: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    loadingActionHistory: false,
    sortBy: 'date',
    sortDesc: true,
    actionHistoryModel: [],
    errors: [],
    headers: [
      { text: 'Action', value: 'action' },
      { text: 'Amount', value: 'amount' },
      { text: 'Date', value: 'date' },
      { text: 'Performed By', value: 'changedByUserId' }
    ],
    actionHistory: []
  }),
  created () {
    this.loadActionHistory()
  },
  mounted () {
    this.loadActionHistory()
  },
  watch: {
    jarId: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.loadActionHistory()
      }
    }
  },

  methods: {

    async loadActionHistory () {
      if (this.jarId == null || this.jarId === '') {
        this.actionHistory = []
        return
      }
      // this.loadingHistory = true
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_JAR}/jars/${this.jarId}/action-history`

      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })
      if (getResponse === undefined) { this.actionHistory = [] } else { this.actionHistory = getResponse.data }
      // this.loadingHistory = false
    },

    formatDate (aDate) {
      return moment(String(aDate)).format('YYYY/MM/DD hh:mm:ss')
    }
  }
}
</script>
<style>
</style>
